import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    fontFamily: "'Inter', sans-serif",
    h5: {
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    subtitle2: {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1024,   // ← bumped up from 900
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: 'rgb(195 44 97 / var(--tw-bg-opacity))',
      contrastText: '#fff',
    },
    background: {
      default: '#FAFBFC',
      paper: '#FFFFFF',
    },
    action: {
      disabled: '#E0E0E0',
      disabledBackground: '#E0E0E0',
    },
    text: {
      disabled: '#9E9E9E',
      primary: '#0A0A0A',
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
      },
    },
  },
});
